export default __webpack_public_path__ + "static/media/015-marshmallow.1ca3f5fb.svg";